export default "__VITE_ASSET__DA482p0S__"